module.exports = __webpack_public_path__ + "static/media/Allalouf.c18a1cf8.PNG";